import { withApollo, graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import CompletePasswordReset from './index';

const resetPasswordMutation = gql`
  mutation MyResetPassword($newPassword: String!, $resetToken: String!) {
    resetPassword(newPassword: $newPassword, resetToken: $resetToken) {
      success
      message
    }
  }
`;

let RequestPasswordResetWithData = withApollo(
  compose(
    graphql(resetPasswordMutation, {
      props({ ownProps, mutate }) {
        return {
          resetPassword: (newPassword, resetToken) => {
            return mutate({
              variables: {
                newPassword: newPassword,
                resetToken: resetToken
              }
            });
          }
        };
      },
      options: {
        errorPolicy: 'all'
      }
    })
  )(CompletePasswordReset)
);

export default RequestPasswordResetWithData;



// WEBPACK FOOTER //
// ./src/components/CompletePasswordReset/CompletePasswordResetWithData.js